$(document).ready(function () {
    $('.btn-accept-disabled').on('click', function (e) {
        e.preventDefault();
        let $acceptBtn = $(this);
        let $agreementCheckbox = $('#agreement-checkbox');

        if (
            $agreementCheckbox.is(':checked')
            && !$acceptBtn.hasClass('acceptance-required')
        ) {
            window.location.href = $acceptBtn.attr('href');
        }
    })

    $('#agreement-checkbox').on('change', function () {
        let $acceptBtn = $('.btn.btn-primary');

        if ($userWarnings.length === 0) {
            $acceptBtn.toggleClass('btn-accept-disabled');
            $acceptBtn[0].toggleAttribute('disabled');
        }
    });

    addEventListener("message", (event) => {
        if (event.data && event.data.type && event.data.type === "hidePriceError") {
            $("#ProjectsTasks_price-error").html('');
        }
    });
});